// extracted by mini-css-extract-plugin
export default {"Underlined":"kXk3bIyM"};